import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import AdminLayout from '../../components/admin/AdminLayout';
import { t } from 'i18next';
import instance from './../../axios/instance';
import { Button } from '@mui/material';
import { useSnackbar } from "notistack";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function AdminRates() {
  const { enqueueSnackbar } = useSnackbar();
  const [rates, setRates] = useState([]);
  useEffect(() => {
    (async () => {
      // Get all rates
      const response = await instance.get("rate/all-rates-admin");
      const data = response.data.data || [];
      setRates(data);
    }
    )();
  },[]);
  async function deleteRate(id) {
    try {
      await instance.delete(`rate/delete-rate/${id}`);
      enqueueSnackbar("تم الحذف بنجاح.", { variant: "success", autoHideDuration: "8000" });
    } catch {
      enqueueSnackbar("حدث خطأ ما", { variant: "error", autoHideDuration: "8000" });
    }
  }

  return (
    <AdminLayout>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>{t("comment")}</StyledTableCell>
              <StyledTableCell align="right">{t("rating")}</StyledTableCell>
              <StyledTableCell align="right">{t("studentId")}</StyledTableCell>
              <StyledTableCell align="right">{t("teacherId")}</StyledTableCell>
              <StyledTableCell align="right">{t("delete")}</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rates.map((rate) => (
              <StyledTableRow key={rate.id}>
                <StyledTableCell component="th" scope="row">
                  {rate.comment}
                </StyledTableCell>
                <StyledTableCell align="right">{rate.rating}</StyledTableCell>
                <StyledTableCell align="right">{rate.StudentId}</StyledTableCell>
                <StyledTableCell align="right">{rate.TeacherId}</StyledTableCell>
                <StyledTableCell align="right">
                  <Button variant="contained" color='error' onClick={() => { deleteRate(rate.id) }}>{t("delete")}</Button>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </AdminLayout>
  )
}

export default AdminRates;
